/*
	Аутентификация пользователя после перезагрузки страницы
	и логинизации
*/
import { IResponse } from "../../types/response.type";
import { apiRequest } from "../http";
import type { User } from "../../types/user.type";

// Типизированный ответ
export type IAuthResponse = IResponse<User>;

export const authMe = async (): Promise<IAuthResponse> => {
	return await apiRequest<User>({
		path: "/api/v1/auth/me",
		method: "GET",
	});
};
